var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ak-form-decorator",
    {
      attrs: {
        id: _vm.id,
        title: _vm.title,
        helpText: _vm.helpText,
        tooltip: _vm.tooltip,
        error: _vm.error,
        hasError: _vm.hasError,
        required: _vm.required,
        value: _vm.value,
        hidden: _vm.hidden,
        errorLocales: _vm.errorLocales,
      },
    },
    [
      _c("div", { staticClass: "ak-form__control-wrapper" }, [
        _c("div", {
          staticClass: "ak-form__color-swatch",
          style: { background: _vm.currentValue },
        }),
        _vm._v(" "),
        _c(
          "input",
          _vm._g(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "ak-form__control ak-form__control--color",
              class: {
                "ak-form__control--has-value": _vm.currentValue,
              },
              attrs: {
                type: "text",
                placeholder: _vm.placeholder,
                readonly: _vm.readOnly,
              },
              domProps: { value: _vm.currentValue },
              on: {
                blur: _vm.blur,
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.showPicker.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.currentValue = $event.target.value
                },
              },
            },
            _vm.$currentListeners
          )
        ),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-down" } },
        [
          _vm.pickerVisible
            ? _c("SketchPicker", {
                directives: [
                  {
                    name: "on-click-outside",
                    rawName: "v-on-click-outside:noChild",
                    value: _vm.hidePicker,
                    expression: "hidePicker",
                    arg: "noChild",
                  },
                ],
                staticClass: "ak-form__color-picker",
                attrs: { "preset-colors": _vm.presetColors },
                model: {
                  value: _vm.currentColor,
                  callback: function ($$v) {
                    _vm.currentColor = $$v
                  },
                  expression: "currentColor",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("popover"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }